module.exports = __webpack_public_path__ + "img/ic-arrow.1fe998d1.svg";